import Parse from "parse";

type OD3_Tenant = Parse.Object;

export interface TenantDomainAttributes {
  id: string;
  objectId: string;
  createdAt: Date;
  updatedAt: Date;
  tenant: OD3_Tenant;
  domain: string;
}

export class TenantDomain extends Parse.Object<TenantDomainAttributes> {
  constructor(data?: Partial<TenantDomainAttributes>) {
    super("APP_TenantDomain", data as TenantDomainAttributes);
  }
}

Parse.Object.registerSubclass("APP_TenantDomain", TenantDomain);
